import { useUserStore } from '@pidz/stores';
import { RouteLocationNormalized } from 'vue-router';

//@TODO add navigation guard to a shared-util lib

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function checkMaxRange(_to: RouteLocationNormalized, _from: RouteLocationNormalized) {
  const userStore = useUserStore()
  if(!userStore.maxWorkRange){
    await userStore.getMaxWorkRange()
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function checkDepartmentCountInRange(_to: RouteLocationNormalized, _from: RouteLocationNormalized) {
  const userStore = useUserStore()
  if(!userStore.departmentCountWithinRange){
    await userStore.fetchDepartmentCountWithinRange(userStore.maxWorkRange!)
  }
}